export default "__VITE_ASSET__Ca1TXgfS__"